module.exports = __webpack_public_path__ + "static/img/status-wait.4cdf84c6.svg";